import { axios } from "@Root/API";

export const getConfirmStudentApplication = (applicationId, studentId) => {
  return axios.get(`confirm-student-application/${applicationId}`, { params: { student_id: studentId } });
};
